import http from '@root/utils/axios/admin';
let state = {

}

let actions = {


    setLike({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/subscriber/like', data).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            })
        });
    },
    setUnLike({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/subscriber/unlike', data).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            })
        });
    },

    setView({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/subscriber/view', data).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            })
        });
    },
    setReport({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/subscriber/report', data).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            })
        });
    },



}


let mutations = {


}

export default {
    state,
    actions,
    mutations
}